import React, { useState } from 'react'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { PersonalForm, PersonalInfo } from './personal-info'
import { makeStyles, Typography } from '@material-ui/core'
import { Address, AddressForm } from './address-form'
import { Phone, PhoneForm } from './phone-form'

export type Person = {
  personalInfo: PersonalInfo;
  addressInfo: Address;
  phone: Phone
}

const useStyles = makeStyles({
  paper: {
    margin: '15px',
    padding: '15px'
  }
})

export interface PersonFormProps {
  value: Person;
  onChange: (person: Person) => void;
  title: string;
  showError?: boolean;
  onErrorChange: (error: boolean) => void;
  disabled?: boolean;
}

export const PersonForm: React.FC<PersonFormProps> = function (props) {
  const { value: person, onChange, title, showError = false, onErrorChange, disabled = false } = props
  const [personalError, setPersonalError] = useState(true)
  const [addressError, setAddressError] = useState(true)
  const styles = useStyles()

  function validate (person: Person) {
    // eslint-disable-next-line no-useless-escape
    onErrorChange(personalError || addressError || !person.phone.phone || !person.phone.phone?.match(/^[-+\/\s]*([0-9][-+\/\s]*){9,}$/))
  }

  function update (key: string, value: any) {
    const newPerson = ({
      ...person,
      [key]: value
    })
    validate(newPerson)
    onChange(newPerson)
  }

  return (
    <Paper className={styles.paper}>
      <Typography variant="h5">{title}</Typography>
      <Grid container direction="column" alignItems="stretch">
        <Grid item>
          <Paper className={styles.paper}>
            <Typography variant="h6">Dane osobowe</Typography>
            <PersonalForm disabled={disabled} showError={showError} value={person.personalInfo} onChange={value => update('personalInfo', value)} onErrorChange={setPersonalError}/>
          </Paper>
        </Grid>
        <Grid item>
          <Paper className={styles.paper}>
            <Typography variant="h6">Dane adresowe</Typography>
            <AddressForm disabled={disabled} value={person.addressInfo} showError={showError} onChange={value => update('addressInfo', value)} onErrorChange={setAddressError} />
          </Paper>
        </Grid>
        <Grid item>
          <Paper className={styles.paper}>
            <Typography variant="h6">Dane kontaktowe</Typography>
            <PhoneForm disabled={disabled} showError={showError} value={person.phone} onChange={value => update('phone', value)} />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  )
}
